import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=b7c7178a&scoped=true"
import script from "./BlackList.vue?vue&type=script&lang=js"
export * from "./BlackList.vue?vue&type=script&lang=js"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=b7c7178a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c7178a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7c7178a')) {
      api.createRecord('b7c7178a', component.options)
    } else {
      api.reload('b7c7178a', component.options)
    }
    module.hot.accept("./BlackList.vue?vue&type=template&id=b7c7178a&scoped=true", function () {
      api.rerender('b7c7178a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/blackList/BlackList.vue"
export default component.exports